import objectUtils from "../../util/objectUtils";
import axios from "axios";

export default {
    state: () => ({
        cmsDataList : null
    }),
    mutations: {
        setCmsDataList:function (state,cmsDataList){
            state.cmsDataList = cmsDataList;
        }
    },
    getters: {
        getCmsDataList : state => {
            return state.marketList
        }
    },
    actions:{
        loadCmsDataList(context){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };
            return axios.get(context.getters.getServiceUrl + "/admin-api/cmsData", {headers})
                .then((response) => {
                    context.commit("setCmsDataList", response.data);
                    return response.data;
                })
        },
        updateCmsDataList(context, request){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };
            return axios.put(context.getters.getServiceUrl + "/admin-api/cmsData", request,{headers})
                .then((response) => {
                    let cmsDataList = context.getters.getCmsDataList;
                    marketList.forEach((market) => {
                        if(response.data.id === market.id) {
                            objectUtils.deepCopy(market, response.data);
                        }
                    });

                    context.commit("setMarketList", marketList);
                    return response.data;
                })

        },
        createMarket(context, request){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };
            return axios.post(context.getters.getServiceUrl + "/admin-api/market", request,{headers})
                .then((response) => {
                    let marketList = context.getters.getMarketList;
                    marketList.push(response.data);

                    context.commit("setMarketList", marketList);
                    return response.data;
                })
        },
        deleteMarket(context,request){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };
            return axios.delete(context.getters.getServiceUrl + "/admin-api/market/"+request.id,{headers})
                .then((response) => {
                    let marketList = context.getters.getMarketList;
                    marketList = marketList.filter(market=>{
                        return market.id !== request.id;
                    });
                    context.commit("setMarketList", marketList);
                    return response.data;
                })
        },
    }
}